import { SoilMoistureSarClassMap } from "../shared/models/soil-moisture-model";

export const OPERATORS = {
    "HEAD": "Head",
    "CAPELLA": "Capella",
    "SATELLOGIC": "Satellogic",
    "AT21": "21AT",
    "UMBRA": "Umbra",
    "STE": "STE",
    "KOMPSAT": "KOMPSAT",
    "USL": "USL",
    "ISI" : "ISI",
    "AXELSPACE" : "AxelSpace",
    "GHG" : "GHG",
    "ORORATECH": "Ororatech",
    "SATVU": "SatVu",
    "BLACKSKY": "Blacksky",
    "WYVERN" : "Wyvern",
    "SPIRE": "Spire",
    "CLYDE": "ClydeSpace",
    "SYNSPECTIVE": "Synspective",
    "GOKTURK": "Gokturk",
    "LBAND": "Spire-RF",
    "ECURS": "ECURS",
    "ESPER": "Esper",
    "STE_TELEOS": "STE_TELEOS",
    "PIXXEL": "Pixxel",
    "OSK": "OSK",
    "ECURS_L": "ECURS_L",
    "AZISTA" : "Azista",
    "SATELLITEVU_VANZYL" : "SatelliteVu_VanZyl",
    "FIREFLIES": "Fireflies",
    "SDS": "SDS",
    "ORBVIEW": "Orbview",
    "GEOSAT": "Geosat",
    "ICEYE": "ICEYE",
    "WEATHEREX": "WeatherEx",
    "AISSTREAM": "AISstream",
    "VOYAGERADAR": "VoyageRadar",
    "CONSTELLR": "Constellr",
    "SENTINEL": "Sentinel",
    "VESSELFINDER": "VesselFinder",
}

// Operators whose license requires "Image supplied by <supplier>" on the collection map, keyed by operatorKey.
export const IMAGE_ATTRIBUTION_SUPPLIERS: Record<string, string> = {
    [OPERATORS.STE]: 'ST Engineering',
    [OPERATORS.STE_TELEOS]: 'ST Engineering',
    [OPERATORS.ICEYE]: 'ICEYE',
};

export const DEFAULT_ZOOMLEVEL = 13;

const tiffbaseurl = 'https://d2mc32y2ywna9c.cloudfront.net/common/Sample+Tiff';

export const TiffUrls = {
  "Head(0.75m)": [`${tiffbaseurl}/Daily+Vision+MSI/Tiles/{z}/{x}/{y}.png`,[[-1.1501495345701465, 121.57017120795199], [-1.1311340541828343, 121.54770729589083]]],
  "Head(0.5m)": [`${tiffbaseurl}/EarthScaner/Tiles`,[[-1.1501661512598396, 121.57015890801213], [-1.1311180878182054, 121.54769128360523]]],
  "Head(3.0114m)": [`${tiffbaseurl}/Head/hsi.tiff`],
  "Capella(0.25m)": null,
  "Capella(1m)": null,
  "Capella(1.2m)": [`${tiffbaseurl}/Capella/Capella_1.2_Tiles`,[[9.677724034950407, 115.91431091885956], [9.78320264925368, 115.8092612601121]]],
  "Satellogic(0.7m)": [`${tiffbaseurl}/Satellogic/Satellogic_70cm_Tiles/{z}/{x}/{y}.png`, [[32.82068163255413, 13.321397252851078], [32.9120227895531, 13.234169783558803]]],
  "Satellogic(0.99m)": [`${tiffbaseurl}/Satellogic/Satellogic_90cm_Tiles/{z}/{x}/{y}.png`, [[32.82067803378436, 13.321394035113297], [32.9120227895531, 13.234169783558803]]],
  "21AT": [`${tiffbaseurl}/21AT/21AT-Tiles/{z}/{x}/{y}.png`, [[1.261665614232121, 103.97037738799578], [1.2959396979247686, 103.93139232936736]]],
  "Umbra": [`${tiffbaseurl}/Umbra/UMBRA-Tiles/{z}/{x}/{y}.png`, [[9.872574985657023, 115.52670690181324], [9.925750753441454, 115.47303201595392]]],
  "STE": [`${tiffbaseurl}/NeuSAR/Tiles/{z}/{x}/{y}.png`, [[9.884627185721452, 115.55099595989194], [9.925105455609726, 115.51013704377041]]],
  "KOMPSAT(0.85m)": null,
  "KOMPSAT(1m)": null,
  "KOMPSAT(2.5m)": null,
  "KOMPSAT(20m)": null,
  "USL": null,
  "ISI(0.69m)" : [`${tiffbaseurl}/EROS-B/Tiles/{z}/{x}/{y}.png`,[[10.966394790923884, 114.29697204876526], [11.148734672284657, 114.15681532707369]]],
  "ISI(0.4m)" : [`${tiffbaseurl}/EROS-C/Tiles/{z}/{x}/{y}.png`,[[9.837430611697306, 115.58706271952431], [9.975417954449638, 115.4754677219018]]],
  "AxelSpace" : null,
  "GHG" : [`${tiffbaseurl}/GHG/Tiles/{z}/{x}/{y}.png`, [[36.426605493914224, 61.696819505549556], [36.68838588106724, 61.42168291387832]]],
  "Ororatech": null,
  "SatVu": null,
  "Blacksky": [`${tiffbaseurl}/BlackSky/Tiles/{z}/{x}/{y}.png`, [[9.880797251906387, 115.54526193095194], [9.955892129289174, 115.4700066725466]]],
  "Wyvern" : [`${tiffbaseurl}/Wyvern/Tiles/{z}/{x}/{y}.png`,[[32.19953104886455, -101.501790183292], [32.236100114878916, -101.53299787464852]]],
  "Spire": '../../../../assets/sensor-images/Spire_1.png',
  "ClydeSpace": '../../../../assets/sensor-images/Clyde_1.png',
  "WeatherEx": '../../../../assets/sensor-images/WeatherEx_1.png',
  "VoyageRadar": '../../../../assets/sensor-images/VoyageRadar_1.png',
  "Synspective": null,
  "Gokturk": null,
  // No dedicated artwork yet — falls back to the generic sensor thumbnail, same as AxelSpace/Ororatech/SatVu above.
  "VesselFinder": '../../../../assets/sensor-images/VesselFinder_1.png',
}

export const videoUrls = {
  "Head": `${tiffbaseurl}/Video+FMV/Video_FMV.mp4`,
  "Umbra": `${tiffbaseurl}/Umbra/Umbra_SAR_FMV.gif`
}

export const ZOOM_SCALES = {
  0: 156543,
  1: 78272, 
  2: 39136,
  3: 19568,
  4: 9784,
  5: 4892,
  6: 2446,
  7: 1223,
  8: 611.5, 
  9: 305.8,
  10: 152.9, 
  11: 76.4,
  12: 38.22,    
  13: 19.11,    
  14: 9.56, 
  15: 4.78,    
  16: 2.39,    
  17: 1.2,     
  18: 0.5972,
  19: 0.2986,
  20: 0.1493,
  21: 0.0746,
  22: 0.0373,
  23: 0.0187,
};

export const STATUS_MAP = {
    completed: 'done',
    approved: 'done',
    ordered: 'done',
    archived: 'done',
    restored: 'done',
    delivering: 'wip',
    pending: 'wip',
    awaiting: 'wip',
    'cancel requested': 'wip',
    rejected: 'canceled',
    canceled: 'canceled',
    failed: 'canceled',
    collected: 'wip',
    'pending approval': 'wip',
    'approval rejected': 'canceled',
    'Unavailable': 'Unavailable'
  };

  export const CONFIG_VALUES = {
   "AxelCustomerId" : "659b53fd474336f361dfeb06",
   "numberFormat": '1.2-2',
  };

  export const AT21_RESPONSE_TIME = {
    'standard': 45,
    'priority': 25,
    'rush': 1
  }

  export const supportEmail = "support@eartheye.space"

  export const BANK_DETAILS = {
    'accountHolder' : 'EARTHEYE SPACE TECH PTE LTD',
    'accountNumber' : '261-021273-178',
    'SWIFTcode' : 'HSBCSGSG',
    'bankName' : 'THE HONGKONG AND SHANGHAI BANKING CORPORATION LIMITED SINGAPORE',
    'bankAddress' : 'MARINA BAY FINANCIAL CENTRE TOWER 2 48-01 10 MARINA BOULEVARD SINGAPORE 018983'
  }

  export const EMAIL_REGEX = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@(?!gmail|yahoo|outlook|hotmail)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*\.([a-zA-Z]{2,})$/; 

  export const STRIPE_CHARGE = 3.9;

  export const PAYPAL_CHARGE = 4.1;

  export const STRIPE_FEE = 0.95749; //(1-(3.9%+ (9%*3.9%)))

  export const PAYPAL_FEE = 0.95531; //(1-(4.1%+ (9%*4.1%)))

  export const RF_RADIUS = 1500; //In km

  export const PIXXEL_RADIUS = 5.641895835; // In km
  
  export const OPTICAL_EMBARGO_AMOUNT = 1000;

  export const SAR_EMBARGO_AMOUNT = 2000;

  export const STEREO_EMBARGO_AMOUNT = 5000;

  export const HSI_EMBARGO_AMOUNT = 1000;

  export const Video_EMBARGO_AMOUNT = 6000;

  export function formatCurrency(value: number | null | undefined): string {
    if (value === null || value === undefined) return 'US$ 0.00';
    return 'US$ ' + Intl.NumberFormat('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(value);
  }

  export  const dollarUS = {
    format: (value: number) => formatCurrency(value),
  };

  export const polarization = {
    "Capella": 'HH',
    "KOMPSAT": 'HH',
    "Umbra" : 'VV',
    "STE" : 'HH,VV,HV,VH',
    "ECURS" : 'VV',
    "ECURS_L" : 'VV',
    "STE_TELEOS" : 'HH,VV,HV,VH',
  }

  export const CAPELLA_MODES = {
    'spotlight_ultra': 'POI',
    'spotlight': 'POI',
    'spotlight_wide': 'POI',
    'stripmap_20': 'POI',
    'stripmap_50': 'POI',
    'stripmap_100': 'AOI'
  }

  export const SENSOR_BAND_DATA = {
    Head: [
      { name: 'B0', startWavelength: 450, endWavelength: 800, gsd: 5, characteristics: 'Panchromatic Band' },
      { name: 'B1', startWavelength: 403, endWavelength: 423, gsd: 5, characteristics: 'Sensitive band to yellow substances' },
      { name: 'B2', startWavelength: 433, endWavelength: 453, gsd: 5, characteristics: 'Coastal band' },
      { name: 'B3', startWavelength: 450, endWavelength: 515, gsd: 5, characteristics: 'Blue band' },
      { name: 'B4', startWavelength: 525, endWavelength: 600, gsd: 5, characteristics: 'Green band' },
      { name: 'B5', startWavelength: 630, endWavelength: 680, gsd: 5, characteristics: 'Red band' },
      { name: 'B6', startWavelength: 784.5, endWavelength: 899.5, gsd: 5, characteristics: 'Leaf Area Index (LAI)/Near Infrared' },
      { name: 'B7', startWavelength: 485, endWavelength: 495, gsd: 10, characteristics: 'Chlorophyll and other pigments' },
      { name: 'B8', startWavelength: 615, endWavelength: 625, gsd: 10, characteristics: 'Sediment transport' },
      { name: 'B9', startWavelength: 650, endWavelength: 680, gsd: 10, characteristics: 'Chlorophyll absorption peak spectrum' },
      { name: 'B10', startWavelength: 698.75, endWavelength: 718.75, gsd: 10, characteristics: 'Chlorophyll fluorescence reference spectrum' },
      { name: 'B11', startWavelength: 732.5, endWavelength: 747.5, gsd: 10, characteristics: 'Red edge spectrum' },
      { name: 'B12', startWavelength: 773, endWavelength: 793, gsd: 10, characteristics: 'Leaf area index spectrum (LAI)' },
      { name: 'B13', startWavelength: 855, endWavelength: 875, gsd: 20, characteristics: 'Sensitive to cholorophyll, biomass, LAI' },
      { name: 'B14', startWavelength: 660, endWavelength: 670, gsd: 20, characteristics: 'Chlorophyll, sediment transport, sediment' },
      { name: 'B15', startWavelength: 677.5, endWavelength: 685, gsd: 20, characteristics: 'Chlorophyll fluorescence peak spectrum, red edge spectrum' },
      { name: 'B16', startWavelength: 750, endWavelength: 757.5, gsd: 20, characteristics: 'O2 absorption reference spectrum' },
      { name: 'B17', startWavelength: 758.75, endWavelength: 762.5, gsd: 20, characteristics: 'O2 absorption spectrum' },
      { name: 'B18', startWavelength: 935, endWavelength: 955, gsd: 20, characteristics: 'Water vapor correction' },
      { name: 'B19', startWavelength: 1000, endWavelength: 1040, gsd: 20, characteristics: 'Atmosphere and aerosol correction' },

    ],

    Wyvern_23: [
      { "sl": 1, "bandName": "Band_503nm", "commonName": "Green" },
      { "sl": 2, "bandName": "Band_510nm", "commonName": "Green" },
      { "sl": 3, "bandName": "Band_520nm", "commonName": "Green" },
      { "sl": 4, "bandName": "Band_535nm", "commonName": "Green" },
      { "sl": 5, "bandName": "Band_550nm", "commonName": "Green" },
      { "sl": 6, "bandName": "Band_570nm", "commonName": "Green" },
      { "sl": 7, "bandName": "Band_585nm", "commonName": "Green" },
      { "sl": 8, "bandName": "Band_600nm", "commonName": "Green" },
      { "sl": 9, "bandName": "Band_615nm", "commonName": "Red" },
      { "sl": 10, "bandName": "Band_635nm", "commonName": "Red" },
      { "sl": 11, "bandName": "Band_650nm", "commonName": "Red" },
      { "sl": 12, "bandName": "Band_660nm", "commonName": "Red" },
      { "sl": 13, "bandName": "Band_670nm", "commonName": "Red" },
      { "sl": 14, "bandName": "Band_680nm", "commonName": "Red-Edge" },
      { "sl": 15, "bandName": "Band_690nm", "commonName": "Red-Edge" },
      { "sl": 16, "bandName": "Band_700nm", "commonName": "Red-Edge" },
      { "sl": 17, "bandName": "Band_712nm", "commonName": "Red-Edge" },
      { "sl": 18, "bandName": "Band_722nm", "commonName": "Red-Edge" },
      { "sl": 19, "bandName": "Band_735nm", "commonName": "Red-Edge" },
      { "sl": 20, "bandName": "Band_750nm", "commonName": "Red-Edge" },
      { "sl": 21, "bandName": "Band_765nm", "commonName": "Near Infrared (NIR)" },
      { "sl": 22, "bandName": "Band_782nm", "commonName": "Near Infrared (NIR)" },
      { "sl": 23, "bandName": "Band_800nm", "commonName": "Near Infrared (NIR)" }
    ],

    Wyvern_31: [
      { "sl": 1, "bandName": "Band_445nm", "commonName": "Blue" },
      { "sl": 2, "bandName": "Band_464nm", "commonName": "Blue" },
      { "sl": 3, "bandName": "Band_480nm", "commonName": "Blue" },
      { "sl": 4, "bandName": "Band_490nm", "commonName": "Blue" },
      { "sl": 5, "bandName": "Band_503nm", "commonName": "Green" },
      { "sl": 6, "bandName": "Band_510nm", "commonName": "Green" },
      { "sl": 7, "bandName": "Band_519nm", "commonName": "Green" },
      { "sl": 8, "bandName": "Band_534nm", "commonName": "Green" },
      { "sl": 9, "bandName": "Band_550nm", "commonName": "Green" },
      { "sl": 10, "bandName": "Band_569nm", "commonName": "Green" },
      { "sl": 11, "bandName": "Band_585nm", "commonName": "Green" },
      { "sl": 12, "bandName": "Band_600nm", "commonName": "Green" },
      { "sl": 13, "bandName": "Band_614nm", "commonName": "Red" },
      { "sl": 14, "bandName": "Band_634nm", "commonName": "Red" },
      { "sl": 15, "bandName": "Band_650nm", "commonName": "Red" },
      { "sl": 16, "bandName": "Band_659nm", "commonName": "Red" },
      { "sl": 17, "bandName": "Band_669nm", "commonName": "Red" },
      { "sl": 18, "bandName": "Band_679nm", "commonName": "Red-Edge" },
      { "sl": 19, "bandName": "Band_689nm", "commonName": "Red-Edge" },
      { "sl": 20, "bandName": "Band_700nm", "commonName": "Red-Edge" },
      { "sl": 21, "bandName": "Band_712nm", "commonName": "Red-Edge" },
      { "sl": 22, "bandName": "Band_722nm", "commonName": "Red-Edge" },
      { "sl": 23, "bandName": "Band_734nm", "commonName": "Red-Edge" },
      { "sl": 24, "bandName": "Band_749nm", "commonName": "Red-Edge" },
      { "sl": 25, "bandName": "Band_764nm", "commonName": "Near Infrared (NIR)" },
      { "sl": 26, "bandName": "Band_781nm", "commonName": "Near Infrared (NIR)" },
      { "sl": 27, "bandName": "Band_799nm", "commonName": "Near Infrared (NIR)" },
      { "sl": 28, "bandName": "Band_814nm", "commonName": "Near Infrared (NIR)" },
      { "sl": 29, "bandName": "Band_832nm", "commonName": "Near Infrared (NIR)" },
      { "sl": 30, "bandName": "Band_849nm", "commonName": "Near Infrared (NIR)" },
      { "sl": 31, "bandName": "Band_869nm", "commonName": "Near Infrared (NIR)" }
    ],
     STE_TELEOS: [
      { "sl": 1, "color": "RED", "pol": "HH-VV", "usecase": "Man-made structures" },
      { "sl": 2, "color": "GREEN", "pol": "HH+VV", "usecase": "Natural Vegetation(e.g Trees, grass)" },
      { "sl": 3, "color": "BLUE", "pol": "HV+VH", "usecase": "Man-made structures" }
    ]
  };

  export const posthogkeys = {
    "apiHost": 'https://us.i.posthog.com'
  }

  export const USER_CAN_DEPOSIT = 8;
  export const DELEGATE_MY_TASKS = 7;
  export const TIP_CUE_WORKFLOW = 9;
  export const QUESTION_BASED_WORKFLOW = 10;
  export const OUTCOME_BASED_WORKFLOW = 11;
  export const TLE_BASED_TASKING_WORKFLOW = 12;
  export const CHANGE_DETECTION_WORKFLOW = 13;
  export const USER = 'user';
  export const VESSEL_PREDICTION = 'vessel_prediction';

  export const SOIL_MOISTURE_SAR_CLASS_MAP: SoilMoistureSarClassMap = {
  1: { label: 'Very Dry',  color: '#e54e35' },
  2: { label: 'Dry',       color: '#fdbb6c' },
  3: { label: 'Moderate',  color: '#feffbe' },
  4: { label: 'Moist',     color: '#b3df72' },
  5: { label: 'Very Moist',color: '#3faa59' }
  } as const;

  export const FLOOD_INUNDATION_DEPTH_CLASS_MAP: Record<string, { label: string; color: string }> = {
    '<0.5 m':          { label: '<0.5 m',          color: '#67e8f9' },
    '0.5\u20131.0 m': { label: '0.5–1.0 m', color: '#38bdf8' },
    '1.0\u20132.0 m': { label: '1.0–2.0 m', color: '#0284c7' },
    '2.0\u20133.0 m': { label: '2.0–3.0 m', color: '#1d4ed8' },
    '3.0\u20135.0 m': { label: '3.0–5.0 m', color: '#1e3a8a' },
    '>5.0 m':          { label: '>5.0 m',          color: '#4c1d95' },
  };

  export const VESSEL_CLASS_COLOR_MAP = {
    aircraft_carriers: { label: 'Aircraft carrier', color: '#8E44AD' },
    cargo_ship: { label: 'Cargo (container) carrier', color: '#E67E22' },
    dry_bulk: { label: 'Dry bulk', color: '#3498DB' },
    oil_tankers: { label: 'Oil tanker', color: '#2ECC71' }
  } as const;

  export const VESSEL_CLASS_COLOR_MAP_LEGEND = {
    aircraft_carrier: { label: 'Aircraft carrier', color: '#8E44AD' },
    "cargo_(container)_carrier": { label: 'Cargo (container) carrier', color: '#E67E22' },
    dry_bulk: { label: 'Dry bulk', color: '#3498DB' },
    oil_tanker: { label: 'Oil tanker', color: '#2ECC71' }
  } as const;

  export const VEHICLE_CLASS_COLOR_MAP = {
    'Lorries':        { label: 'Lorries',        color: '#E67E22' },
    'Trailers':       { label: 'Trailers',       color: '#3498DB' },
    'Pick-up trucks': { label: 'Pick-up trucks', color: '#2ECC71' },
    'Cars':           { label: 'Cars',           color: '#FF9999' },
  } as const;

  export const VEHICLE_CLASS_COLOR_MAP_LEGEND = {
    'Lorries':        { label: 'Lorries',        color: '#E67E22' },
    'Trailers':       { label: 'Trailers',       color: '#3498DB' },
    'Pick-up trucks': { label: 'Pick-up trucks', color: '#2ECC71' },
    'Cars':           { label: 'Cars',           color: '#FF9999' },
  } as const;

  export const ROAD_CLASS_MAP = {
    1: { label: 'Highway', color: '#FFA500' },
    2: { label: 'Urban', color: '#FFFF00' },
  } as const;

  export const LAND_USE_LAND_COVER_CLASS_MAP = {
    1: { label: 'Built-up', color: '#B22222' },
    2: { label: 'Roads', color: '#FFA500' },
    3: { label: 'Water', color: '#1E90FF' },
    4: { label: 'Open area', color: '#DEB887' },
    5: { label: 'Agriculture/fallow land', color: '#FF69B4' },
    6: { label: 'Tree/Forest', color: '#228B22' },
    7: { label: 'Plantation', color: '#32CD32' },
  } as const;

  // Keyed by feature.properties.forecast_h
  export const OIL_SPILL_PREDICTION_FORECAST_COLOR_MAP = {
    3: { label: '3h', color: '#FFD700' },
    6: { label: '6h', color: '#FF8C00' },
    12: { label: '12h', color: '#FF4500' },
    24: { label: '24h', color: '#8B0000' },
  } as const;

  export const MINING_CHANGES_MONITORING_CLASS_MAP = {
    Baseline: { label: 'Baseline', color: '#2ECC71' },
    Change: { label: 'Latest Change', color: 'RED' },
  } as const;

  // Prediction points are keyed by detection class and forecast hour.
  export const OIL_SPILL_PREDICTION_CLASS_FORECAST_COLOR_MAP = {
    1: {
      3: { color: '#FFD700' },
      6: { color: '#FF8C00' },
      12: { color: '#FF4500' },
      24: { color: '#8B0000' },
    },
    2: {
      3: { color: '#00E5FF' },
      6: { color: '#00A6FF' },
      12: { color: '#0066CC' },
      24: { color: '#003B80' },
    },
    3: {
      3: { color: '#7CFC00' },
      6: { color: '#32CD32' },
      12: { color: '#008F5A' },
      24: { color: '#005A3C' },
    },
  } as const;

  export const PREDICTION_DETECTION_COLOR_MAP = {
    1: { color: '#ac0df7' },
    2: { color: '#008B8B' },
    3: { color: '#7CFC00' },
  } as const;

  // Flood prediction has its own hours (adds 48h) and avoids blue, since Flood Inundation
  // already uses cyan → indigo and the two layers would be indistinguishable.
  export const FLOOD_PREDICTION_FORECAST_COLOR_MAP = {
    3: { label: '3h', color: '#FFD700' },
    6: { label: '6h', color: '#FF8C00' },
    12: { label: '12h', color: '#FF4500' },
    24: { label: '24h', color: '#8B0000' },
    48: { label: '48h', color: '#6B3A00' },
  } as const;

  export const FLOOD_PREDICTION_CLASS_FORECAST_COLOR_MAP = {
    1: {
      3: { color: '#FFD700' },
      6: { color: '#FF8C00' },
      12: { color: '#FF4500' },
      24: { color: '#8B0000' },
      48: { color: '#6B3A00' },
    },
    2: {
      3: { color: '#FF80BF' },
      6: { color: '#FF00FF' },
      12: { color: '#B266FF' },
      24: { color: '#800080' },
      48: { color: '#4B0082' },
    },
    3: {
      3: { color: '#7CFC00' },
      6: { color: '#008000' },
      12: { color: '#20B2AA' },
      24: { color: '#808000' },
      48: { color: '#2F4F4F' },
    },
  } as const;

  export const FLOOD_PREDICTION_DETECTION_COLOR_MAP = {
    ...PREDICTION_DETECTION_COLOR_MAP,
    2: { color: '#FF1493' },
    // Detection 3's default (#7CFC00) matches its 3h forecast color.
    3: { color: '#00FA9A' },
  } as const;

  // Prediction feeds share one flow (detections + forecast points, filter, legend, timeseries).
  // A new prediction feed type only needs an entry here plus its feedsConfig entries.
  export const PREDICTION_FEED_TYPES: Record<string, {
    filterType: string;
    label: string;
    sectionTitle: string;
    color: string;
  }> = {
    'Oil-spill-prediction': {
      filterType: 'oilSpillPrediction',
      label: 'oil spill prediction',
      sectionTitle: 'Oil spill prediction',
      color: '#FF00FF',
    },
    'flood-prediction': {
      filterType: 'floodPrediction',
      label: 'flood prediction',
      sectionTitle: 'Flood prediction',
      color: '#13b6f7',
    },
  };

  export function isPredictionFeedType(type: any): boolean {
    return type != null && Object.prototype.hasOwnProperty.call(PREDICTION_FEED_TYPES, type);
  }

  export function getPredictionFeedMeta(type: any) {
    return isPredictionFeedType(type) ? PREDICTION_FEED_TYPES[type] : undefined;
  }

  export function isPredictionFilterType(filterType: any): boolean {
    return Object.values(PREDICTION_FEED_TYPES).some((meta) => meta.filterType === filterType);
  }

  export const PREDICTION_FILTER_TYPES = Object.values(PREDICTION_FEED_TYPES).map(
    (meta) => meta.filterType
  );

  export const feedsConfig = {
  '65bb95f1e182770007a2a49a': {type: 'Land use/land cover detection',colorMode: 'CLASS_BASED',color: LAND_USE_LAND_COVER_CLASS_MAP},
  '6a0d704e1fc5f8016b1f53ad': {type: 'Land use/land cover detection',colorMode: 'CLASS_BASED',color: LAND_USE_LAND_COVER_CLASS_MAP},
  '6523b3555da10d5cdca01d18': {type: 'Land use/land cover detection',colorMode: 'CLASS_BASED',color: LAND_USE_LAND_COVER_CLASS_MAP},
  '67eb94f1f13a5bafcea9042a': { type: 'Flood', filterKey: 'Waterbody', color: "#a8d1ec" },
  '67ff656928067bacfa1e5598': { type: 'Deforestation', areaSqKm: 4.38, color: "SANDYBROWN" },
  '67eb94faf13a5bafcea9042c': { type: 'Oil', color: "MAGENTA" },
  '684a78879c263cbd085e668c': { type: 'Plantation', color: "YELLOW" },
  '67eb94c6f13a5bafcea90420': {type: 'Tree counting', color: "#006400"},
  '67eb92aff13a5bafcea9040c': {type: 'Vessel', filterKey: 'wake',class: 'ship', color: "YELLOW"},
  '67eb92c1f13a5bafcea90410': {type: 'Vessel', filterKey: 'wake',class: 'ship', color: "YELLOW"},
  '67eb94cdf13a5bafcea90422': {type: 'Vessel', filterKey: 'wake',class: 'ship', color: "YELLOW"},
  '67eb94e9f13a5bafcea90428': {type: 'Vessel', filterKey: 'wake',class: 'ship', color: "YELLOW"},
  '67eb92b8f13a5bafcea9040e': {type: 'Vessel', filterKey: 'wake',class: 'ship', color: "YELLOW"},
  '68d506ed0b875d40d8c6fb79': {type: 'Path', color: '#ba5a06'},
  '68d348a93a43fb9ded6352c4': {type: 'Path', color: '#ba5a06'},//DEMO
  '68d319a04f2c0663c98b9f8e': {type: 'Path', color: '#ba5a06'},//PROD - DEV
  '691eeae3a4b6f1998767b3a4': {type: 'Path-SAR', color: '#ba5a06'},
  

  '6523b3225da10d5cdca01d14': { type: 'Flood', filterKey: 'Waterbody', color: "#a8d1ec" },
  '6752f2cee98a8160322eb5dd': { type: 'Deforestation', areaSqKm: 4.38,  color: "SANDYBROWN" },
  '67bdca4b59e4151725eb30db': { type: 'Oil', color: "MAGENTA" },
  '68423bb51943da5f46599663': { type: 'Deforestation', color: "SANDYBROWN" },
  '6752f2ace98a8160322eb5d9': {type: 'Tree counting', color:"#006400"},
  '673c1a52e6ccaa847010cf98': {type: 'Ship', filterKey: 'wake', color: "YELLOW"},
  '673c4706e6ccaa847010cfe6': {type: 'Transhipment', filterKey: 'wake', color: "RED"},
  '673c478ce6ccaa847010cff1': {type: 'Ship', filterKey: 'wake', color: "YELLOW"},
  '6617e8e07243db1e9df258ce': {type: 'Transhipment', filterKey: 'wake', color: "RED"},
  '6523b1d75da10d5cdca01d06': {type: 'Ship', filterKey: 'wake', color:"YELLOW"},

  '65bb95e0e182770007a2a498': { type: 'Flood', filterKey: 'Waterbody', color: "#a8d1ec" },
  '67bdc8c67dc8e5af7df4afde': { type: 'Oil',  color: "MAGENTA" },
  '68ee1af101be10b56fc2a013': { type: 'Plantation', color: "YELLOW" },
  '691ee673feb09573ccc821db': { type: 'Plantation', color: "YELLOW" },
  '691ee72aa4b6f1998767b2f0': { type: 'Plantation', color: "YELLOW" },
  '67904650a5a20bad89281100': {type: 'Tree counting', color:"#006400"},

  '67387f66cf43b2ae2f814484': {type: 'Ship', filterKey: 'wake',  color: "YELLOW"},
  '65bb95a8e182770007a2a492': {type: 'Ship', filterKey: 'wake',  color: "YELLOW"},
  '67388027cf43b2ae2f81449d': {type: 'Transhipment', filterKey: 'wake',  color: "RED"},
  '6638d9253ad8139306d74a11': {type: 'Transhipment', filterKey: 'wake',  color: "RED"},
  '67388091cf43b2ae2f8144a6': {type: 'Ship', filterKey: 'wake',  color: "YELLOW"},
  '690201c66d0a85ed9db7edeb': {type: VESSEL_PREDICTION},
  '69090ccf21ac1f09f2668b95': {type: VESSEL_PREDICTION},
  '692548523d5ef5e82efdd1ee': {type: 'Plantation-SAR', color: "YELLOW"},
  '69254a51cdc0508da1299c73': {type: 'Plantation-SAR', color: "YELLOW"},
  '692548c93d5ef5e82efdd1fe': {type: 'Path-SAR', color: '#ba5a06'},
  '6925498acdc0508da1299c68': {type: 'Path-SAR', color: '#ba5a06'},
  '691f578fa4b6f1998767b3e4': {type: 'Soil Moisture - SAR', colorMode: 'CLASS_BASED', color: SOIL_MOISTURE_SAR_CLASS_MAP},
  '69579cd8556cb0c44b0c0865': {type: 'Soil Moisture - SAR', colorMode: 'CLASS_BASED', color: SOIL_MOISTURE_SAR_CLASS_MAP},
  '695baf514c046a01b6ab3e77': {type: 'Soil Moisture - SAR', colorMode: 'CLASS_BASED', color: SOIL_MOISTURE_SAR_CLASS_MAP},
  '69a8024c3a56fde9f2c10b0e': {type: 'Transhipment', filterKey: 'wake', color: "RED"},
  '69a5a1139aaedcab0052c617': {type: 'Transhipment', filterKey: 'wake', color: "RED"},
  '69a5a1aef11c0e6d344bc5e7': {type: 'Transhipment', filterKey: 'wake', color: "RED"},
  '65bb95b4e182770007a2a493': {type: 'Vessel-classification', colorMode: 'CLASS_BASED', color_legend: VESSEL_CLASS_COLOR_MAP_LEGEND, color: VESSEL_CLASS_COLOR_MAP},
  '6523b1f55da10d5cdca01d09': {type: 'Vessel-classification', colorMode: 'CLASS_BASED', color_legend: VESSEL_CLASS_COLOR_MAP_LEGEND, color: VESSEL_CLASS_COLOR_MAP},
  '68ee1c22652b467e44f0df5f': {type: 'Plantation-MSI', color: "YELLOW"},
  '69b7e1adc6e8dd4a71679891': {type: 'Road-classification', colorMode: 'CLASS_BASED', color: ROAD_CLASS_MAP},
  '6523b2c65da10d5cdca01d0f': {type: 'Road-classification', colorMode: 'CLASS_BASED', color: ROAD_CLASS_MAP},
  '65bb95cfe182770007a2a496': {type: 'Road-classification', colorMode: 'CLASS_BASED', color: ROAD_CLASS_MAP},
  '69eb07ebdcbc64369822a87d': {type: 'Container detection', color: '#FF00FF'}, //DEV
  '69ef243531b10a0e7f405f77': {type: 'Container detection', color: '#FF00FF'}, //DEMO
  '69ef63160f04e64eb9b6a56f': {type: 'Container detection', color: '#FF00FF'}, //STAGING
  '69ef2507a4366ac0fb7cb373': {type: 'Container detection', color: '#FF00FF'}, //PROD
  '69d7ba869b2f429e1b0aa328': {type: 'Tuna-detection', color:"#27ae60"}, // dev
  '69afddcb1b58d6a7bc0fe00b': {type: 'Tuna-detection', color:"#27ae60"}, // demo
  '69afdb378b8d02ed106b1a2c': {type: 'Tuna-detection', color:"#27ae60"}, // prod
  '69fc686e5411118d8aea5b8a': {type: 'Oil spill type', color:"MAGENTA"}, //DEV
  '69fd83e4598e90d0b3ee84c5': {type: 'Oil spill type', color:"MAGENTA"}, //DEMO
  '69fdeb4a30f5d4c17c9f123b': {type: 'Oil spill type', color:"MAGENTA"}, //STAGING
  '69fd836a09290364d33fb6fa': {type: 'Oil spill type', color:"MAGENTA"}, //PROD

  // Flood Inundation
  '6a67275db813f4b57f7ee5ab': { type: 'Flood Inundation', colorMode: 'CLASS_BASED', color: FLOOD_INUNDATION_DEPTH_CLASS_MAP }, //DEV
  '6a86f9bbd68e72930a9ad34e': { type: 'Flood Inundation', colorMode: 'CLASS_BASED', color: FLOOD_INUNDATION_DEPTH_CLASS_MAP }, //DEMO
  '6a743f838c4ad9b9896658a5': { type: 'Flood Inundation', colorMode: 'CLASS_BASED', color: FLOOD_INUNDATION_DEPTH_CLASS_MAP }, //STAGING
  '6a86f8525767e6473a566964': { type: 'Flood Inundation', colorMode: 'CLASS_BASED', color: FLOOD_INUNDATION_DEPTH_CLASS_MAP }, //PROD
  // Vehicle-identification — replace placeholder IDs with real feed IDs once API is available
  '6a6af0675fd2d88eeddc7c09': {type: 'Vehicle-classification', colorMode: 'CLASS_BASED', color_legend: VEHICLE_CLASS_COLOR_MAP_LEGEND, color: VEHICLE_CLASS_COLOR_MAP}, //DEV
  '6a69c2bf92752f2a4fa027b0': {type: 'Vehicle-classification', colorMode: 'CLASS_BASED', color_legend: VEHICLE_CLASS_COLOR_MAP_LEGEND, color: VEHICLE_CLASS_COLOR_MAP}, //DEMO
  '6a6b17588c4ad9b9896653bd': {type: 'Vehicle-classification', colorMode: 'CLASS_BASED', color_legend: VEHICLE_CLASS_COLOR_MAP_LEGEND, color: VEHICLE_CLASS_COLOR_MAP}, //STAGING
  '6a74be1e6e3134487bd6aa3b': {type: 'Vehicle-classification', colorMode: 'CLASS_BASED', color_legend: VEHICLE_CLASS_COLOR_MAP_LEGEND, color: VEHICLE_CLASS_COLOR_MAP}, //PROD
  '6a0d50741fc5f8016b1f530d': {type: 'small-boat', color: "YELLOW"}, //DEV
  '6a0d70ce1b119378761bda1a': {type: 'small-boat', color: "YELLOW"}, //DEMO
  '6a68907e0437940d5ae61ccd': {type: 'small-boat', color: "YELLOW"}, //staging
  '6a69a856dc1df90330a4a785': {type: 'small-boat', color: "YELLOW"}, //PROD
  '6a71b22eb9fb40eb0e33f7a6': {
    type: 'Oil-spill-prediction',
    color: '#FF00FF',
    forecastColorMap: OIL_SPILL_PREDICTION_FORECAST_COLOR_MAP,
    classForecastColorMap: OIL_SPILL_PREDICTION_CLASS_FORECAST_COLOR_MAP,
    detectionColorMap: PREDICTION_DETECTION_COLOR_MAP,
  }, //DEV
  '6a9aa9725c02468d3ad7006b': {
    type: 'Oil-spill-prediction',
    color: '#FF00FF',
    forecastColorMap: OIL_SPILL_PREDICTION_FORECAST_COLOR_MAP,
    classForecastColorMap: OIL_SPILL_PREDICTION_CLASS_FORECAST_COLOR_MAP,
    detectionColorMap: PREDICTION_DETECTION_COLOR_MAP,
  }, //STAGING
  '6abbac6a6d5bfef40a8590aa': {
    type: 'Oil-spill-prediction',
    color: '#FF00FF',
    forecastColorMap: OIL_SPILL_PREDICTION_FORECAST_COLOR_MAP,
    classForecastColorMap: OIL_SPILL_PREDICTION_CLASS_FORECAST_COLOR_MAP,
    detectionColorMap: PREDICTION_DETECTION_COLOR_MAP,
  }, //DEMO
   '6abbab247dd2bf8f45745ced': {
    type: 'Oil-spill-prediction',
    color: '#FF00FF',
    forecastColorMap: OIL_SPILL_PREDICTION_FORECAST_COLOR_MAP,
    classForecastColorMap: OIL_SPILL_PREDICTION_CLASS_FORECAST_COLOR_MAP,
    detectionColorMap: PREDICTION_DETECTION_COLOR_MAP,
  }, //PROD
  '6adb07830a9dfb73547b8135': {
    type: 'flood-prediction',
    color: '#6211e6',
    forecastColorMap: FLOOD_PREDICTION_FORECAST_COLOR_MAP,
    classForecastColorMap: FLOOD_PREDICTION_CLASS_FORECAST_COLOR_MAP,
    detectionColorMap: FLOOD_PREDICTION_DETECTION_COLOR_MAP,
  }, //DEV
  '6ae85fe241ed8c1d244beafa': {
    type: 'flood-prediction',
    color: '#6211e6',
    forecastColorMap: FLOOD_PREDICTION_FORECAST_COLOR_MAP,
    classForecastColorMap: FLOOD_PREDICTION_CLASS_FORECAST_COLOR_MAP,
    detectionColorMap: FLOOD_PREDICTION_DETECTION_COLOR_MAP,
  }, //STAGING
  '6ae5652c5be95fa0cd617966': {
    type: 'flood-prediction',
    color: '#6211e6',
    forecastColorMap: FLOOD_PREDICTION_FORECAST_COLOR_MAP,
    classForecastColorMap: FLOOD_PREDICTION_CLASS_FORECAST_COLOR_MAP,
    detectionColorMap: FLOOD_PREDICTION_DETECTION_COLOR_MAP,
  }, //DEMO
  '6ae563ff40f5f43ddebfde20': {
    type: 'flood-prediction',
    color: '#6211e6',
    forecastColorMap: FLOOD_PREDICTION_FORECAST_COLOR_MAP,
    classForecastColorMap: FLOOD_PREDICTION_CLASS_FORECAST_COLOR_MAP,
    detectionColorMap: FLOOD_PREDICTION_DETECTION_COLOR_MAP,
  }, //PROD
  '6aab6593e771c5b342a83674': {type: 'Aircraft', color: "YELLOW"}, //DEV
  '6aba154292f6fa154d1570c4': {type: 'Aircraft', color: "YELLOW"}, //STAGING
  '6abd10956d5bfef40a8590f0': {type: 'Aircraft', color: "YELLOW"}, //DEMO
  '6abd114a7dd2bf8f45746419': {type: 'Aircraft', color: "YELLOW"}, //PROD
  '6a61f016f6de4b8e211fafd1': {type: 'Mining changes monitoring', colorMode: 'CLASS_BASED', color: MINING_CHANGES_MONITORING_CLASS_MAP, requiresSentinelMsiSarAgreement: true }, //DEV
  '6aaa4faebaecbd22981cce63': {type: 'Mining changes monitoring', colorMode: 'CLASS_BASED', color: MINING_CHANGES_MONITORING_CLASS_MAP, requiresSentinelMsiSarAgreement: true }, //STAGING

};

export const SENTINEL_AGREEMENT_FEED_IDS =
  (Object.entries(feedsConfig) as Array<
    [string, { requiresSentinelMsiSarAgreement?: boolean }]
  >)
    .filter(([, config]) => config?.requiresSentinelMsiSarAgreement === true)
    .map(([feedId]) => feedId);
export const ASSOCIATED_FEED_LIGHT_MAGENTA = '#f3abf3';
 

  export const SUPER_USER = 'Super user';
  export const BUFFER_AMT = 1000;
  export const BUDGET = 'budgets';
  export const ANNOTATION = 'annotation';
  export const GEO_FENCING = 'geo-fencing';
  export const POINT_TASKING = 'collection-point-tasking';
  export const PDF_REPORT = 'pdf-report';
  export const PAYNOW = 'pay-now';
  export const DEBIT_ACCOUNT = 'debit-account';
  export const PAYLATER = 'pay-later';
  export const TARGET_DELIVERY = 'target-delivery';
  export const VALUE_ADDED_DATA_PRODUCTS = 'value-added-data-products';
  export const FEEDS = 'feeds';
  export const DATA_CATALOG = 'data-catalog';
  export const USERS = 'multi-user';
  export const QUOTES = 'quotes';
  export const PREVIEW = 'preview';
  export const ACTIVITY_LOG = 'activity-log';
  export const MIN_RF_COLLECTION = 1;
  export const MAX_RF_COLLECTION = 2;
  export const INDICES_DELIVERY_TIME = '<5 mins from data delivery';
  export const ANSWER_FIRST = 'answer-first';
  export const ANOUNCEMENTS_OPTIONS = [
  { label: '7 Days', value: 'last7days' },
  { label: '30 Days', value: 'last30days' },
  { label: '60 Days', value: 'last60days' },
  { label: '90 Days', value: 'last90days' },
  { label: 'This Month', value: 'thisMonth' },
  { label: 'Last Month', value: 'lastMonth' }
];

export  const DISPLAYORDER = [
  'Specific Date',
  'Specific Day',
  'Recurrent',
  'Period'
];

export const DAYS_OF_WEEK = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday'
];
